import { render, staticRenderFns } from "./WPageError.vue?vue&type=template&id=78d301de&"
import script from "./WPageError.vue?vue&type=script&lang=ts&"
export * from "./WPageError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports